import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import de from "../../../assets/svg/de.3e64eec7.svg";
import gb from "../../../assets/svg/gb.18c468c4.svg";
import jp from "../../../assets/svg/jp.452ff6dd.svg";
import us from "../../../assets/svg/us.88560635.svg";
const FLAG_MAP = {
  gb,
  us,
  de,
  jp
};
const Icons24CircleFlag = forwardRef(({ flag, ...props }, ref) => {
  return /* @__PURE__ */ jsx("img", { alt: "Flag icon", ...props, ref, src: FLAG_MAP[flag] });
});
export {
  Icons24CircleFlag
};
